import { createContext, useContext, useEffect, useState } from "react";

/* Site language (NO default, EN on request). The choice is a functional preference stored in
   localStorage ("rbtun_lang") – it only remembers the visitor's own language selection. */
const KEY = "rbtun_lang";
const LangCtx = createContext({ lang: "no", setLang: () => {} });

const initial = () => {
  try {
    return localStorage.getItem(KEY) === "en" ? "en" : "no";
  } catch {
    return "no";
  }
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(initial);
  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "nb";
  }, [lang]);
  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem(KEY, l); } catch { /* storage unavailable */ }
  };
  return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

/* Pick the dictionary for the active language: const t = useT({ no: {...}, en: {...} }) */
export const useT = (dict) => dict[useLang().lang] ?? dict.no;
